import axios from "axios";
import { env } from "../../shared/config/env";
import { attachAuthInterceptor } from "./authInterceptor";

const rmsClient = axios.create({
  baseURL: env.api.rms,
  headers: { "Content-Type": "application/json" },
});

attachAuthInterceptor(rmsClient);

export default rmsClient;
